import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import webOrderFormReducer from '../reducers/webOrderFormReducer';

const configureStore = (railsProps) => (
  createStore(webOrderFormReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
